export enum ServiceStatusEnum {
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
  REPORTED = 4,
  DELETED = 5,
  DRAFT = 6,
  PURCHASED = 7,
}

export enum ServiceTimeCountTypeEnum {
  DAYS = "DAYS",
  WEEKS = "WEEKS",
  MONTHS = "MONTHS",
}

export enum ServiceQuestionnaireAnswerTypeEnum {
  FREE_TEXT = "freeText",
  MULTIPLE_CHOICE = "multipleChoice",
  FILE = "file",
}

export const ServicePublishedStatuses = [
  ServiceStatusEnum.APPROVED,
  ServiceStatusEnum.REPORTED,
  ServiceStatusEnum.PURCHASED,
];
